<template>
  <b-nav :hidden="!isAdminStatus">
    <b-nav-item-dropdown
        id="my-nav-dropdown "
        text="Troubleshooting"
        toggle-class="nav-link-custom"
    >
      <template slot="button-content">
        <i class="fa mr-2 fa-tools text-indigo" font-scale="1"></i>
        <span>Troubleshooting</span>
      </template>

      <!-- <slot v-for="(item, index) in troubleLinks" name="title">
        <b-dropdown-item :to="item.url">
          <i :class="`${item.icon} text-${item.color} pr-2`"></i>
          {{ item.label }}
        </b-dropdown-item>
      </slot> -->

      <!-- <b-dropdown-item to="/graphing">
        <i class="fa fa-cogs text-" font-scale="1"></i>
        Diameter Usage Graphing
      </b-dropdown-item> -->
      <b-dropdown-item href="http://10.56.0.108/enum/" target="_blank" >
        <i class="fa fa-signal text-green" font-scale="1"></i>
        ENUM Status
      </b-dropdown-item>
      <b-dropdown-item href="http://10.57.0.50/otz/cwstats.php" target="_blank">
        <i class="fa fa-chart-area text-indigo" font-scale="1"></i>
        IMS KIP Graphing
      </b-dropdown-item>
      <b-dropdown-item href="http://10.57.0.50/otz/subscriber-status.php" target="_blank">
        <i class="fa fa-user text" font-scale="1"></i>
        IMS Subscriber Status
      </b-dropdown-item>
      <!-- <b-dropdown-item to="/aaa_log_download">
        <i class="fa fa-cog text-blue" font-scale="1"></i>
        AAA Log Download
      </b-dropdown-item> -->
      <b-dropdown-item href="http://198.140.29.21:1785/log-search.php" target="_blank">
        <i class="fa fa-envelope text-blue" font-scale="1"></i>
        SMS Router Logs
      </b-dropdown-item>
      <!-- <b-dropdown-item to="/aaa_log_search">
        <i class="fa fa-digital-tachograph text-indigo" font-scale="1"></i>
        AAA Log Search
      </b-dropdown-item> -->
      <!-- <b-dropdown-item to="/broadband_graphs">
        <i class="fa fa-chart-area text-green" font-scale="1"></i>
        OTZ Broadband Graphs
      </b-dropdown-item> -->
      <!-- <b-dropdown-item to="/roaming_heatmap">
        <i class="fa fa-map-marked text-yellow" font-scale="1"></i>
        OTZ Roaming Heatmap
      </b-dropdown-item> -->
      <b-dropdown-item to="/overwatch">
        <i class="fa fa-cogs text-red" font-scale="1"></i>
        Overwatch
      </b-dropdown-item>
      <b-dropdown-item href="http://10.57.0.50/otz/custom/sms-mt.php" target="_blank">
        <i class="fa fa-mail-bulk text-purple" font-scale="1"></i>
        SMS MT Queue
      </b-dropdown-item>
      <b-dropdown-item href="http://10.57.0.50/otz/sms.php" target="_blank">
        <i class="fa fa-file-invoice text-blue" font-scale="1"></i>
        SMS Subscriber Tracing
      </b-dropdown-item>
      <b-dropdown-item to="/serviceassurance">
        <i class="fa fa-tools text-orange" font-scale="1"></i>
        Service Assurance
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </b-nav>
</template>
<script>
import initService from '../../../common/api-services/init-service';
import configDirective from '../../../common/directive/config-directive';
import AuthService from "@/common/api-services/auth-service";

export default {
  name: 'top-trouble-custom-group',
  components: {},
  data() {
    return {
      isAdminStatus: false,
      groups: [],
      troubleLinks: [],
      troubleCollaps: false,
    }
  },
  mounted() {
    // this.troubleLinks = configDirective.getTroubleLinks();
    //console.log('trouble:', this.troubleLinks);
    this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
  },
}
</script>
